<div class="row">
  <div class="big-title" [class.clickable]="config.titleLink" (click)="navigate()">
    <i *ngIf="config.icon" class="{{config.icon}}"></i>
      {{config.title.label | translate:config.title.params}} {{ extraText }}
  </div>
  <div class="actions" *ngIf="config.actions">
    <span *ngFor="let action of config.actions" class="icon {{action.icon!}}"
          (click)="onActionClick.emit(action)"></span>
  </div>
</div>
